import React, { useState, useEffect, useRef } from 'react';
import { ContentBox } from "../ContentBox"
import { SystemPromptInput } from '../../Res/SystemPrompt';
import 'rc-datepicker/lib/style.css';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { Pagination } from '../../Res/Pagination';
import { ReqPermissionList, ReqPermission, RespPermissionList } from '../../../../item/ItemPermission';
import { api_getDefaultPermissionList, api_setPermission } from '../../../../api/apiPermission';
import { RespRoleDetail } from '../../../../item/ItemRole';
import { SingleCheckBox } from '../../Res/BaseInput';
import { CancelSubmitButton } from '../../Res/BaseButton';
import Swal from 'sweetalert2';
import { getUserInfoCompanyId } from '../../../Login/Auth';

export function DepartmentPositionPermission({ id, setIsLoading }) {
    const [companyId] = useState(getUserInfoCompanyId())
    const [roleId, setRoleId] = useState("")
    const [roleName, setRoleName] = useState("")
    const [permissionList, setPermissionList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)

    const [defaultList, setDefaultList] = useState([])

    const isSelect = useRef(false);
    const [init, setInit] = useState(false)

    useEffect(() => {
        if (id !== undefined && id !== roleId) {
            setRoleId(id)
        }
    }, [id])

    useEffect(() => {
        if (roleId !== "") {
            confirmSearch({ page: 1 })
        }
    }, [roleId])

    useEffect(()=>{
        console.log(isSelect)
    },[isSelect])

    // useEffect(()=>{
    //     // console.log(permissionList)
    //     if(permissionList.length > 0){
    //         if(init && !isSelect.current){
    //             console.log('setSelect')
    //             if(!isSelect.current){
    //                 isSelect.current = true
    //             }
    //         }else{
    //             console.log('setInit')
    //             setInit(true)
    //         }
    //     }
    // },[permissionList])

    function checkIsSelect(){
        return isSelect.current
    }

    // useEffect(()=>{
    //     if(Object.keys(mReqEmployeeResumeList).length !== 0){
    //         toSearch({items: mReqEmployeeResumeList})
    //     }
    // },[mReqEmployeeResumeList])


    function toSearch({ page = 1 }) {
        if(isSelect.current){
            Swal.fire({
              type: 'warning',
              title: '提醒',
              text: '您的資料有異動！',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              confirmButtonText: '不儲存離開',
              cancelButtonText: '留在本頁',
            }).then(function (result) {
              // console.log(result)
              if (result.value) {
                confirmSearch({page})
              }
            })
        }else{
            confirmSearch({page})
        }
    }

    function confirmSearch({ page = 1 }){
        isSelect.current = false
        // setChange(false)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqPermissionList = new ReqPermissionList({ companyId, roleId, start, limit })
        getPermissionList(mReqPermissionList)
    }

    async function getPermissionList(mReqPermissionList) {
        // console.log(isSelect)
        setIsLoading(true)
        api_getDefaultPermissionList({
            mReqPermissionList,
            success: (obj) => {
                // console.log(obj)
                var mRespRoleDetail = new RespRoleDetail({})
                mRespRoleDetail.fromJson(obj.role)
                // console.log(mRespRoleDetail.roleName)
                setRoleName(mRespRoleDetail.roleName)
                setPermissionList(obj.list)
                var mRespPermissionList = new RespPermissionList({})
                mRespPermissionList.fromJson(obj.list)
                setDefaultList(mRespPermissionList.list)
                setCount(obj.count)
        console.log(isSelect.current)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }

    function setList(pageId, isView) {
        // console.log(selectFilter)

        //console.log(permissionList)
        var changeFilterEmpty = permissionList.filter(function (item, index, array) {
            //console.log(item.pageId + " : "+ defaultItem.pageId)
            return item.pageId === pageId
        });
        if(changeFilterEmpty.length > 0){
            changeFilterEmpty[0].isView = isView
        }
        
        isSelect.current = true
        // console.log(changeFilterEmpty)
        // console.log(permissionList)
        var list = []
        permissionList.forEach(item=>{
            list.push(item)
        })
        setPermissionList(list)
    }
    
    function toEdit() {
        setIsLoading(true)
        isSelect.current = false
        //console.log(permissionList)
        //console.log(defaultList)
        var mRespPermissionList = []
        permissionList.map(item=>{
            var filterEmpty = defaultList.filter((defaultItem)=>{
                return (item.pageId === defaultItem.pageId && item.isView !== defaultItem.isView)
            })
            if(filterEmpty.length > 0){
                //console.log(filterEmpty[0])
                filterEmpty[0].roleId = roleId
                filterEmpty[0].isView = item.isView
                mRespPermissionList.push(filterEmpty[0])
            }
        })
        console.log(mRespPermissionList)
        if(mRespPermissionList.length === 0){
            setIsLoading(false)
            // Swal.fire({
            //   type: 'error',
            //   title: '提醒',
            //   text: "無更新內容",
            // })
            return
        }
        api_setPermission({
            mRespPermissionList,
            success:(jsonData)=>{
                console.log(jsonData)
                setIsLoading(false)
                Swal.fire({
                  type: 'success',
                  title: '提醒',
                  text: "更新完成",
                })
            },
            failure:(err)=>{
                console.log(err)
                setIsLoading(false)
                Swal.fire({
                  type: 'error',
                  title: '提醒',
                  text: err.message,
                })
            }
        })
    }

    function toCancel() {
        window.history.back();
    }

    var baseTitle = <>{roleName} &ensp; 權限列表 </>
    var baseContent =
        <>
            <div className="row m-b-sm">
            </div>
            <ListBox permissionList={permissionList} action={setList} count={count} page={page} sp={toSearch} check={checkIsSelect} />
        </>

    var footer =
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toEdit} />
    return (
        <>
            <ContentBox title={baseTitle} content={baseContent} footer={footer} hasDrawer={false} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}


function ListBox({ permissionList, action, count, page, sp , check}) {
    const [mPermissionList, setPermissionList] = useState()
    const [mPermissionItemList, setPermissionItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (permissionList !== undefined && mPermissionList !== permissionList) {
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + permissionList.length)
            setPermissionItemList(setTableList(permissionList))
            setPage(page)
            setPermissionList(permissionList)
        }

    }, [permissionList])

    useEffect(() => {
        if (count !== mCount) {
            setCount(count)
        }
    }, [count])

    function setTableList(permissionList) {
        var list = []
        for (var i = 0; i < limit; i++) {
            if (permissionList[i] !== undefined) {
                list.push(<PermissionBox key={permissionList[i].pageId} permission={permissionList[i]} action={action} />)
            } else {
                list.push(<PermissionBox key={"resumeId" + i} />)
            }
        }
        return list
    }

    function sPage(p) {
        // console.log("pagechange" + p)
        // console.log("isSelect " + check())
        if (p !== page) {
            sp({ page: p })
            if(!check())
                setPage(p)
        }
    }

    if (mPermissionItemList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-3">頁面</th>
                                    <th className="text-center sorting col-sm-4">說明</th>
                                    <th className="text-center sorting col-sm-3">網頁名稱</th>
                                    <th className="text-center sorting col-sm-2">允許進入</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    mPermissionItemList.map((permission) => (
                                        permission
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function PermissionBox({ permission, action }) {
    const [mPermission, setPermission] = useState({})
    const [pageName, setPageName] = useState("")
    const [pageDescription, setPageDescription] = useState("")
    const [pageLink, setPageLink] = useState("")
    const [isView, setIsView] = useState(0)

    useEffect(() => {
        if (permission !== undefined && permission !== mPermission) {
            //console.log(department)
            setPermission(permission)
            setPageName(permission.pageName)
            setPageDescription(permission.pageDescription)
            setPageLink(permission.pageLink)
            setIsView(permission.isView)
        }
    }, [permission])

    function setChoose(val) {
        //console.log(val)
        if (action !== undefined) {
            action(mPermission.pageId, val)
        }
    }

    return (
        <tr role="row">
            <td className="text-center">{pageName}&nbsp;</td>
            <td className="text-center">{pageDescription}</td>
            <td className="text-center">{pageLink}</td>
            <td className="text-center">
                {
                    Object.keys(mPermission).length === 0 ? <></> : <SingleCheckBox isCheck={isView} setCheck={setChoose} />
                }
            </td>
        </tr>
    )
}
